// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const masquerain: PokeData = {
  "id": 284,
  "name": "masquerain",
  "height": 8,
  "weight": 36,
  "base_experience": 159,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "supersonic",
    "mist",
    "water-gun",
    "bubble-beam",
    "stun-spore",
    "agility",
    "quick-attack",
    "haze",
    "bubble",
    "scary-face",
    "giga-drain",
    "baton-pass",
    "sweet-scent",
    "air-cutter",
    "silver-wind",
    "water-sport",
    "air-slash",
    "bug-buzz",
    "aqua-jet",
    "ominous-wind",
    "quiver-dance",
    "soak",
    "sticky-web"
  ],
  "moves": [
    "gust",
    "supersonic",
    "bubble-beam",
    "stun-spore",
    "quick-attack",
    "bubble",
    "scary-face",
    "air-slash",
    "bug-buzz",
    "aqua-jet",
    "sticky-web",
    "brave-bird",
    "infest"
  ],
  "evolution_chain": {
    "id": 141,
    "item": null,
    "species": [
      {
        "name": "surskit",
        "order": 309,
        "types": [
          PokeType.BUG,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "masquerain",
        "order": 310,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 283,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 113,
    "speed": 127,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
